import React, {useContext} from 'react';
import {GoogleLogin} from '@react-oauth/google';
import {googleLoginRequest} from 'util/api';
import {PopupContext} from 'popup/Popup';

const GoogleLogic = ({onMissingUserName, isBlue = false}) => {
    const {setDisableBackgroundClose} = useContext(PopupContext);

    const handleSuccess = async (credentialResponse) => {
        try {
            const loginResponse = await googleLoginRequest(credentialResponse.credential);
            if (!loginResponse.hasNickname) {
                setDisableBackgroundClose(true);
                onMissingUserName();
            } else {
                localStorage.setItem('isLoggedIn', 'true');
                window.location.reload();
            }
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    const handleError = () => {
        console.error('Login Failed');
    };

    return (
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            theme={isBlue ? 'filled_blue' : 'outline'}
            size="large"
            shape={isBlue ? 'pill' : 'rectangular'}
            width={isBlue ? '226' : '240'}
        />
    );
};

export default GoogleLogic;
